module.exports = __webpack_public_path__ + "static/animation-38c2da29f3c36f6e0cdc21f3870c5051.gif";